import React from 'react';

import Typography, { TypographyProps } from '@mui/material/Typography';
import { SxProps, Theme } from '@mui/material/styles';

type Props = {
  /** テキスト内容 */
  children: React.ReactNode;
  /** 追加のsxスタイル（mb等を上書き可能） */
  sx?: SxProps<Theme>;
  /** Typography component prop */
  component?: TypographyProps['component'];
};

/**
 * ワークフロー記事内のプレーンテキスト共通コンポーネント。
 * Typography variant="body2" color="text.secondary" を統一スタイルで提供する。
 *
 * デフォルト: mb=1.5, lineHeight=1.9
 */
const WorkflowText: React.FC<Props> = ({ children, sx, component }) => {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      component={component as React.ElementType}
      sx={{ mb: 1.5, lineHeight: 1.9, ...sx }}
    >
      {children}
    </Typography>
  );
};

export default WorkflowText;
